import { useMutation } from '@apollo/client';
import { Box, Divider, Hidden, Page, PageBlock } from 'braid-design-system';
import { useEffect } from 'react';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { VerifyEmailAlert } from 'src/components/VerifyEmailAlert';
import { useAuth } from 'src/hooks/auth';

import Confirmation from './components/Confirmation/Confirmation';
import SEND_BOOSTED_AD_ENQUIRY from './queries/sendBoostedAdEnquiry';

const PAGE_WIDTH = 'small';

const BoostedAd = () => {
  const [boostedAdSignup, { loading, called }] = useMutation(
    SEND_BOOSTED_AD_ENQUIRY,
  );

  const { getAuthToken } = useAuth();

  useEffect(() => {
    const token = getAuthToken();
    if (Boolean(token) && !called) {
      boostedAdSignup();
    }
  });

  return (
    <Page footer={<SiteWideFooter />} footerPosition="belowFold">
      <Header title="Buying a business" />

      <Hidden below="tablet">
        <Divider />
      </Hidden>

      <VerifyEmailAlert width={PAGE_WIDTH} />

      <Box paddingTop="xlarge">
        <PageBlock width={PAGE_WIDTH}>
          {loading ? <CustomLoader /> : <Confirmation />}
        </PageBlock>
      </Box>
    </Page>
  );
};

export default BoostedAd;
